/* eslint-disable */
export default {
  searchPlaceholder: 'Search...',
  refresh: 'Refresh',
} as const;

// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
// @key: @#@"refresh"@#@ @source: @#@"Refresh"@#@
